module.exports = __webpack_public_path__ + "static/media/S-5-Y.b28b519c.mp3";